import React from 'react';
import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useSkeletonStyles = makeStyles({
  root: {
    background: 'var(--colorSkeletonBackground)'
  }
});

const Skeleton: React.FC<MuiSkeletonProps> = props => {
  const classes = useSkeletonStyles();
  return <MuiSkeleton {...props} animation="pulse" classes={{ root: classes.root }} />;
};

export default Skeleton;
